import {Injectable} from '@angular/core';
import {ViewConfig} from '../../model/api/view-config';
import {Trade} from '../../model/clearing/trade';
import {AccountDefinition} from '../../model/customer/account-definition';
import {FieldRecord} from '../../model/api/field-record';
import {ExchangeDetail} from '../../model/exchange/exchange-detail';
import CallPut = Trade.CallPut;
import {DatePipe, DecimalPipe} from "@angular/common";
import {OrdersTradesTableRequest} from "../../model/clearing/orders-trades-table-request";
import {OrdersTradesFilter} from "../../model/clearing/orders-trades-filter";
import StateFilter = OrdersTradesFilter.StateFilter;
import {TableColumnConfig} from "../../model/api/table-column-config";
import {AppConfigService} from "../app-config.service";
import {ClearingSelectionInfo} from "../../model/clearing/clearing-selection-info";

@Injectable({providedIn: 'root'})
export class ClearingTableConfigTradeAggregService {

  constructor(  public appConfigService: AppConfigService) {
  }

  buildTableConfig(viewConfig: ViewConfig, visibleColumns: string[],
                   exchanges: FieldRecord<ExchangeDetail>[],
                   filterWithValue: any[]): any[] {

    const availableColumnFilters = this.appConfigService.tradeAggregationColumns.filter(value => value.filterable && !value.hidden).map(value => value.field);

    const columnsConfig: TableColumnConfig[] = JSON.parse(JSON.stringify(this.appConfigService.tradeAggregationColumns));
    columnsConfig.forEach(value => {
      if (availableColumnFilters.includes(value.field)) {
        value.hidden = filterWithValue.includes(value.field)
      }
      if (!value.hidden && !value.notFilterable) {
        value.filterConfig = {type: 'text', matchMode: 'contains', values: undefined};
      }
      if (value.field === 'count') {
        value.mapId = record => record.itemIds ? record.itemIds.length : 0;
      } else if (value.field === 'exchangeCode') {
        value.icon = (record: any) => {
          if (record.exchangeCode) {
            const exchField = exchanges ? exchanges.find(field => field.value
              && field.value.code === record.exchangeCode) : undefined;
            if (exchField && exchField.value) {
              return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
            } else {
              return '';
            }
          }
          return '';
        }
      } else if (value.field === 'buyTotalVolume') {
        value.style = record => 'color:var(--yellowgreen) !important;'
      } else if (value.field === 'sellTotalVolume') {
        value.style = record => 'color:var(--tomato) !important;'
      } else if (!(value.field in new ClearingSelectionInfo())) {
        value.mapId = record => record[value.field] ? record[value.field] : (record.additionalFields[value.field] ? record.additionalFields[value.field] : '');
      }
    });

    viewConfig.templateRows.forEach(value => {
      const fieldName = value.viewColumn.field == 'account' ? 'accountName' : value.viewColumn.field;
      const columnConfig: TableColumnConfig = columnsConfig.find(columnConf => columnConf.field === fieldName);
      if (columnConfig) {
        if (value.headerBackColor || value.headerForeColor) {
          let style = '';
          style += value.headerBackColor ? 'background: var(--' + value.headerBackColor.toLowerCase() + ') !important' : '';
          if (style.length > 0 && value.headerForeColor) style += ';';
          style += value.headerForeColor ? 'color: var(--' + value.headerForeColor.toLowerCase() + ') !important' : '';
          columnConfig.headerStyle = style;
        }
        if (value.contentColorFormat) {
          columnConfig.style = (record) => {
            let style = '';
            if (value.contentColorFormat.startsWith('*:')) {
              // const color = !this.themeService.isDarkTheme && ClearingTableBaseComponent.colorMapToLight[value.contentColorFormat.split(':')[1].toLowerCase()] ?
              //   ClearingTableBaseComponent.colorMapToLight[value.contentColorFormat.split(':')[1].toLowerCase()] : value.contentColorFormat.split(':')[1].toLowerCase();
              style += 'color:var(--' + value.contentColorFormat.split(':')[1].toLowerCase() + ') !important;';
            } else if (value.contentColorFormat === 'side_ColorCode') {
              let sideColor = (record.side === Trade.Side.BUY ? 'var(--yellowgreen)' : 'var(--tomato)');
              style += 'color:' + sideColor + ' !important;';
            }
            return style;
          };
        }
      }
    });
    if (visibleColumns && visibleColumns.length > 0) {
      columnsConfig.sort((a, b) => visibleColumns.indexOf(a.field) - visibleColumns.indexOf(b.field));
    }

    // id is used for row identity/selection but must never be a visible column
    columnsConfig.forEach(c => { if (c.field === 'id') c.hidden = true; });

    return columnsConfig;
  }

}
